exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0cf32214] .el-input-number.is-without-controls .el-input__inner{text-align:left}", ""]);

// exports
